import { PermissionsList } from '@modules/permissions/constants';
import { Permission } from '@modules/permissions/utils';

export const TRANSLATION_PLAYER_BONUS_EDIT = Symbol('players-bonus.edit');
export const ADMIN_PLAYERS_BONUSES_EDIT_ROUTE_NAME = Symbol('admin.players.bonuses.edit');

export const PLAYER_BONUS_QUERY_KEY = Symbol('player-bonus');
export const PLAYER_BONUS_API_URL = (id: string): string => `admin/bonuses/${id}`;

export const PLAYER_BONUS_EDIT_QUERY_KEY = Symbol('player-bonus.edit');

export const PLAYER_BONUS_EDIT_PERMISSIONS = {
  PLAYER_BONUS_EDIT: new Permission(
    PermissionsList.admin.BONUSES_EDIT,
  ),
};
